import { API_URL } from '@funnels/constants';
import { ABNDetail, ABNDetailsSimplified } from '@funnels/types';
import { datadogUtil } from '@funnels/utils';

import { axios } from './axios';

export function searchABNByName(query: string): Promise<ABNDetailsSimplified[]> {
  return axios
    .get(`${API_URL}/v1/abn/by-name/${encodeURI(query)}`)

    .then((res) => {
      const results = res.data.data;
      return results;
    })
    .catch((err) => {
      datadogUtil.addError(err);
      return [];
    });
}

export function searchABN(query: string): Promise<ABNDetail> {
  return axios
    .get(`${API_URL}/v1/abn/by-abn/${encodeURI(query)}`)
    .then((res) => {
      const results = res.data.data;
      return results;
    })
    .catch((err) => {
      datadogUtil.addError(err);
      throw err; // Rethrow for useUpdateEmploymentABN
    });
}
